import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';
import EditButton from '../../../common/button/EditButton';
import { CIRCUIT_PATH } from '../../../../config/paths';
import CircuitDeleteButton from './CircuitDeleteButton';

const CircuitToolbar = ({ circuitId }) => (
  <ButtonToolbar className="pull-right">
    <div>
      <EditButton path={`${CIRCUIT_PATH}/${circuitId}/edit`} />{' '}
      <CircuitDeleteButton circuitId={circuitId} />
    </div>
  </ButtonToolbar>
);

CircuitToolbar.propTypes = {
  circuitId: PropTypes.number.isRequired,
};

export default CircuitToolbar;
